import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBorderCloseIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#3C3C3C",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 28L28 12",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 28L12 12",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBorderCloseIcon;
